module.exports = __webpack_public_path__ + "static/media/warm.eebba007.mp3";